// extracted by mini-css-extract-plugin
export var Grid = "Grid-module--Grid--845c2";